import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { usePageTracking } from "@/lib/usePageTracking";
import { CMSProvider } from "@/lib/useCMS";

// Layout
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { WhatsAppButton } from "@/components/layout/WhatsAppButton";

// Pages
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ChairmanMessagePage from "@/pages/ChairmanMessagePage";
import LeadershipPage from "@/pages/LeadershipPage";
import GroupCompaniesPage from "@/pages/GroupCompaniesPage";
import ServicesPage from "@/pages/ServicesPage";
import VisaServicesPage from "@/pages/VisaServicesPage";
import GlobalPresencePage from "@/pages/GlobalPresencePage";
import PartnersPage from "@/pages/PartnersPage";
import AwardsPage from "@/pages/AwardsPage";
import NewsPage from "@/pages/NewsPage";
import TestimonialsPage from "@/pages/TestimonialsPage";
import CareersPage from "@/pages/CareersPage";
import PartnerWithUsPage from "@/pages/PartnerWithUsPage";
import ContactPage from "@/pages/ContactPage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import AdminPage from "@/pages/AdminPage";

function AppContent() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  usePageTracking();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      {!isAdmin && <Header />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/chairman-message" element={<ChairmanMessagePage />} />
          <Route path="/leadership" element={<LeadershipPage />} />
          <Route path="/companies" element={<GroupCompaniesPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/visa/:country" element={<VisaServicesPage />} />
          <Route path="/global-presence" element={<GlobalPresencePage />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/awards" element={<AwardsPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/partner-with-us" element={<PartnerWithUsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <WhatsAppButton />}
      <Toaster position="top-right" richColors />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <CMSProvider>
        <AppContent />
      </CMSProvider>
    </BrowserRouter>
  );
}

export default App;
